// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-menu-foldable-multi-select-item-search .cdk-virtual-scroll-content-wrapper,
.fi-menu-foldable-multi-select-item-search .mat-mdc-menu-item-text,
.fi-menu-foldable-sub-menu .cdk-virtual-scroll-content-wrapper,
.fi-menu-foldable-sub-menu .mat-mdc-menu-item-text {
  max-width: 100%;
}
.fi-menu-foldable-multi-select-item-search .mat-mdc-checkbox,
.fi-menu-foldable-sub-menu .mat-mdc-checkbox {
  max-width: 100%;
}
.fi-menu-foldable-multi-select-item-search .mat-mdc-checkbox .mdc-form-field,
.fi-menu-foldable-sub-menu .mat-mdc-checkbox .mdc-form-field {
  max-width: 100%;
}
.fi-menu-foldable-multi-select-item-search .mat-mdc-checkbox .mdc-form-field .mdc-label .filtered-item-name,
.fi-menu-foldable-sub-menu .mat-mdc-checkbox .mdc-form-field .mdc-label .filtered-item-name {
  width: 100%;
  word-wrap: break-word;
}

.fi-menu-foldable-sub-menu .sub-menu-item,
.fi-menu-foldable-sub-menu .select-all-button {
  background-color: unset !important;
  padding: 0 5px 0 16px;
  min-width: 230px;
}
.fi-menu-foldable-sub-menu .sub-menu-item:hover,
.fi-menu-foldable-sub-menu .select-all-button:hover {
  background-color: var(--mat-menu-item-hover-state-layer-color) !important;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-menu-foldable-multi-select-item-search/fi-menu-foldable-multi-select-item-search.component.scss"],"names":[],"mappings":"AAEI;;;;EAEI,eAAA;AACR;AACI;;EACI,eAAA;AAER;AADQ;;EACI,eAAA;AAIZ;AAFgB;;EACI,WAAA;EACA,qBAAA;AAKpB;;AAEI;;EAEI,kCAAA;EACA,qBAAA;EACA,gBAAA;AACR;AAAQ;;EACI,yEAAA;AAGZ","sourcesContent":[".fi-menu-foldable-multi-select-item-search,\r\n.fi-menu-foldable-sub-menu {\r\n    .cdk-virtual-scroll-content-wrapper,\r\n    .mat-mdc-menu-item-text {\r\n        max-width: 100%;\r\n    }\r\n    .mat-mdc-checkbox {\r\n        max-width: 100%;\r\n        .mdc-form-field {\r\n            max-width: 100%;\r\n            .mdc-label {\r\n                .filtered-item-name {\r\n                    width: 100%;\r\n                    word-wrap: break-word;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.fi-menu-foldable-sub-menu {\r\n    .sub-menu-item,\r\n    .select-all-button {\r\n        background-color: unset !important;\r\n        padding: 0 5px 0 16px;\r\n        min-width: 230px;\r\n        &:hover {\r\n            background-color: var(--mat-menu-item-hover-state-layer-color) !important;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
